import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  source: string | object | unknown[];
}


import { ref, watch } from 'vue';
import { languages, highlightAllUnder } from 'prismjs';

import { alert } from '@services/alert';
import { ensure } from '@services/ensure';
import { isString } from '@tools/type-guards';

declare module 'vue/types/vue' {
  export interface Vue {
    JsonView: ComponentWithProps<Props>;
  }
}

Object.assign(languages, {
  json: {
    comment: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    property: { pattern: /"(?:\\.|[^\\"\r\n])*"(?=\s*:)/, greedy: !0 },
    string: { pattern: /"(?:\\.|[^\\"\r\n])*"(?!\s*:)/, greedy: !0 },
    number: /-?\d+\.?\d*(e[+-]?\d+)?/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:true|false)\b/,
    null: /\bnull\b/,
  },
});

const __default__ = { name: 'JsonView' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    source: null
  },
  setup(__props: any) {

const props = __props as {
  source: string | object | unknown[];
};

/**
 * `JsonView` component properties.
 */


const preEl = ref<HTMLPreElement | null>(null);

const markup = ref<string | null>(null);

watch(
  () => props.source,
  (source) => {
    let obj: object = {};
    let error: ErrorLike | null = null;

    try {
      obj = isString(source) ? JSON.parse(source) : source;
    } catch (err) {
      error = ensure.error(err);
    }

    if (error) {
      alert.warning(
        'JSON view: the value provided was not a valid object or JSON string',
      );
    }

    markup.value = JSON.stringify(obj, null, 2);

    setTimeout(() => {
      if (!preEl.value) return;

      preEl.value.innerHTML = '';

      const codeEl = document.createElement('code');
      codeEl.classList.add('language-json');
      codeEl.textContent = markup.value ?? 'null';

      preEl.value.appendChild(codeEl);

      highlightAllUnder(preEl.value);
    });
  },
  { immediate: true },
);

return { __sfc: true,props, preEl, markup }
}

})